import { ArgumentError } from "@baseline/common/errors";

export namespace CardProvider {
  export function create(name: string, options: any): CardProvider {
    const instantiator = providers[name];
    if (!instantiator) throw new ArgumentError(`Unknown provider: ${name}`);
    const provider = instantiator(options);
    return provider;
  }

  export const providers: Record<string, Instantiator> = {};

  export type Instantiator = (options: any) => CardProvider;

  export namespace Instantiator {
    export function isInstantiator(value: any): value is Instantiator {
      return typeof value === "function";
    }
  }
}

export interface CardProvider {
  initializeApiClients(apiOrigin: string, token: string): void;

  paymentSetup(
    transactionId: string,
    encodedSessionData: string,
    componentRef: ComponentRef
  ): Promise<void>;

  tokenizationSetup(
    encodedSessionData: string,
    componentRef: ComponentRef
  ): Promise<void>;

  submitSession(): Promise<{
    customerCreditCardId: string | null;
    refusal: string | null;
  }>;
}
